// src/pinpad/index.js
// PinPad — extracted from index.html (v105.x sprint, auto-generated header).
// Bundled by esbuild into dist/pinpad.js. The HTML loads it via
//   <script src="dist/pinpad.js"></script>
// and call sites use `PinPad.<sub>.<fn>()` (e.g.
//   PinPad.clock.requirePin()
//   PinPad.manager.checkPin()
// ).
//
// Backwards compat: index.html's trailing script block re-exposes the
// moved functions on window so existing call sites — both inline JS and
// onclick="" attributes — keep working without HTML edits.
//
// Free variables (DB, currentUser, currentStore, escapeHtml, WORKER_URL,
// fetch, console, document, window, ...) live in the inline globals
// scope of index.html. esbuild leaves them as bare references at runtime.

// PIN action labels — read by requirePin (below). Moved from index.html
// (v124.50, wave-3 slice 6). Only referenced inside this bundle.
var PIN_ACTION_LABELS = {
  clock_in: '▶ Clock In',
  clock_out: '■ Clock Out',
  break_start: '⏸ Start Break',
  break_end: '▶ End Break',
  attribution: '🔐 Verify identity'
};

// ── clock ─────────────────────────────────────────────
export const clock = {};

function requirePin(staffId, action, time) {
  var s = ALL_STAFF.find(function(x){return x.id===staffId;});
  if (!s) return;
  _pinEntry = '';
  _pinStaffId = staffId;
  _pinAction = action;
  _pinTime = time;
  document.getElementById('pinPadName').textContent = s.name;
  document.getElementById('pinPadAction').textContent = PIN_ACTION_LABELS[action] || action;
  document.getElementById('pinError').textContent = '';
  updatePinDots();
  document.getElementById('pinPad').classList.add('open');
}
clock.requirePin = requirePin;

function closePinPad() {
  document.getElementById('pinPad').classList.remove('open');
  _pinEntry = '';
  _pinStaffId = null;
  _pinAction = null;
  // v57: if an attribution prompt is cancelled, reject the waiting promise
  if (_pinAttributionReject) {
    var rej = _pinAttributionReject;
    _pinAttributionResolve = null;
    _pinAttributionReject = null;
    rej(new Error('Attribution cancelled'));
  }
}
clock.closePinPad = closePinPad;

function updatePinDots() {
  for (var i = 0; i < 6; i++) {
    document.getElementById('pd'+i).classList.toggle('filled', i < _pinEntry.length);
  }
}
clock.updatePinDots = updatePinDots;

function pinKey(digit) {
  // v58: support variable-length PINs (4-6 digits). Auto-submit when length matches
  // the staff member's actual PIN. Cap at 6 digits to prevent runaway entry.
  // v59: client no longer has the PIN itself — uses pin_length from /api/staff.
  if (_pinEntry.length >= 6) return;
  _pinEntry += digit;
  updatePinDots();
  document.getElementById('pinError').textContent = '';
  // Look up the target length and auto-submit when it matches
  var s = ALL_STAFF.find(function(x){return x.id===_pinStaffId;});
  var targetLen = (s && s.pin_length) ? s.pin_length : 6;
  // Clamp min to 4 — shouldn't submit a 1/2/3-digit entry even if length is malformed
  if (targetLen < 4) targetLen = 4;
  if (_pinEntry.length === targetLen) {
    setTimeout(checkClockPin, 80);
  }
}
clock.pinKey = pinKey;

function pinDel() {
  _pinEntry = _pinEntry.slice(0, -1);
  updatePinDots();
  document.getElementById('pinError').textContent = '';
}
clock.pinDel = pinDel;

// ── staff picker / attribution (moved from index.html, v124.50) ────────
// These feed the same PIN pad. State vars (_pinEntry/_pinStaffId/_pinAction/
// _pinTime) + the attribution core (setSessionAttribution/getCurrentAttribution/
// _pinAttributionResolve/Reject) stay DECLARED inline in index.html and resolve
// here by bare name (esbuild leaves them free).

function filterStaffPicker() {
  var q = document.getElementById('spSearch').value;
  renderStaffPickerList(q);
}
clock.filterStaffPicker = filterStaffPicker;

function cancelStaffPicker() {
  document.getElementById('staffPicker').classList.remove('open');
  var rej = _pinAttributionReject;
  _pinAttributionResolve = null;
  _pinAttributionReject = null;
  if (rej) rej(new Error('Attribution cancelled'));
}
clock.cancelStaffPicker = cancelStaffPicker;

function pickStaffForAttribution(staff) {
  document.getElementById('staffPicker').classList.remove('open');
  // Now open the PIN pad for this staff member, with the attribution action
  _pinEntry = '';
  _pinStaffId = staff.id;
  _pinAction = 'attribution';
  _pinTime = null;
  document.getElementById('pinPadName').textContent = staff.name;
  document.getElementById('pinPadAction').textContent = '🔐 Verify identity';
  document.getElementById('pinError').textContent = '';
  updatePinDots();
  document.getElementById('pinPad').classList.add('open');
}
clock.pickStaffForAttribution = pickStaffForAttribution;

// v60: keyboard input fallback for tills with a physical keyboard.
// Only fires when the PIN pad is actually open. Mirrors the on-screen
// buttons exactly — digits feed pinKey, Backspace/Delete feed pinDel,
// Enter triggers an immediate submit (useful when PIN is shorter than
// the auto-submit length), Escape cancels.
document.addEventListener('keydown', function(e) {
  var pad = document.getElementById('pinPad');
  if (!pad || !pad.classList.contains('open')) return;
  // Don't interfere if the user is typing in an input within the pad
  // (currently there isn't one, but defensive).
  if (e.target && (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')) return;
  if (e.key >= '0' && e.key <= '9') {
    e.preventDefault();
    pinKey(e.key);
  } else if (e.key === 'Backspace' || e.key === 'Delete') {
    e.preventDefault();
    pinDel();
  } else if (e.key === 'Enter') {
    e.preventDefault();
    if (_pinEntry.length >= 4) checkClockPin();
  } else if (e.key === 'Escape') {
    e.preventDefault();
    closePinPad();
  }
});

async function checkClockPin() {
  // v79.17: race-condition guard — closePinPad() can fire between the verify
  // request and its response (backdrop click, ESC, idle wipe, re-open for a
  // different staffer). Without this guard, _pinStaffId would be null when
  // the success branch reads it, and we'd call Clock.doAction(null, ...) — which
  // logs "[doClock] staff not found for id: null" and silently drops the
  // action. Capture all four PIN globals into locals up-front; gate every
  // post-await branch with the ownership check below.
  var capturedStaffId = _pinStaffId;
  var capturedAction = _pinAction;
  var capturedTime = _pinTime;
  var capturedEntry = _pinEntry;
  if (capturedStaffId == null) {
    // Defensive — this function is only called from pinKey() which checks
    // entry length, so capturedStaffId should always be populated. If it's
    // not, something else cleared the prompt; bail without doing anything.
    return;
  }
  var s = ALL_STAFF.find(function(x){return x.id===capturedStaffId;});
  // v72: Test-mode bypass removed. All PIN verification now goes through the
  // server-side bcrypt check.
  var verified = false;

  // v59: server-side PIN verification (bcrypt). Replaces client-side pin compare.
  try {
    var res = await DB.staff.verifyPin(capturedStaffId, capturedEntry);
    verified = !!(res && res.valid);
  } catch(e) {
    console.warn('PIN verify failed:', e);
    // Detect rate-limit messages (Worker returns 429 with "Too many" message)
    var msg = String(e && e.message || '');
    var rateLimited = msg.indexOf('Too many') !== -1 || msg.indexOf('429') !== -1;
    // v79.17: only mutate the pad UI if we still own this prompt.
    if (_pinStaffId !== capturedStaffId) return;
    _pinEntry = '';
    updatePinDots();
    // v136.8 (reliability audit): when Shift cannot be reached, say so plainly AND say what
    // to do, so a clock-in is never silently lost: the staffer notes the time for a manager.
    document.getElementById('pinError').textContent = rateLimited
      ? 'Too many attempts — wait a minute'
      : "Can't reach Shift. Try again; if it keeps failing, note your time and tell your manager.";
    return;
  }

  // v79.17: post-await ownership check. If the user closed the pad (or
  // re-opened it for a different staffer), drop the resolved result on the
  // floor — neither success nor failure should run.
  if (_pinStaffId !== capturedStaffId) {
    return;
  }

  if (verified) {
    var sid = capturedStaffId, act = capturedAction, t = capturedTime;
    // v57: any successful PIN entry updates the session attribution — this
    // person has proved who they are, we can credit them for subsequent
    // rota/delivery edits this session without re-prompting.
    setSessionAttribution(sid, s ? s.name : null);

    // v59: consent gate — if this staff member hasn't acknowledged the
    // current privacy notice version, show modal first; only proceed
    // with the requested action after acknowledgement.
    var needsConsent = s && s.consent_version !== CONSENT_VERSION;

    if (act === 'attribution') {
      // Attribution flow — resolve the promise and close the pad, no clock action
      var resolve = _pinAttributionResolve;
      _pinAttributionResolve = null;
      _pinAttributionReject = null;
      closePinPad();
      if (needsConsent) {
        showConsentModal(sid, function(){ if (resolve) resolve(getCurrentAttribution()); });
      } else {
        if (resolve) resolve(getCurrentAttribution());
      }
      return;
    }
    closePinPad();
    if (needsConsent) {
      showConsentModal(sid, function(){ Clock.doAction(sid, act, t); });
    } else {
      Clock.doAction(sid, act, t);
    }
  } else {
    _pinEntry = '';
    updatePinDots();
    // v123.21 (UX review): the server already returns res.warning /
    // res.attemptsRemaining / res.locked (worker /api/verify-pin, 200 body) — but
    // the UI used to show a flat "wrong PIN" right up to a SILENT 15-minute
    // lockout. Surface the warning so a staffer fat-fingering a PIN on a shared
    // till knows before they lock themselves out mid-clock-in.
    var pinMsg = 'Incorrect PIN. Try again';
    if (res && res.locked && /on this connection/.test(res.reason || '')) {
      pinMsg = res.reason;   // v133.35: too many wrong PINs on this till's connection (it says how long)
    } else if (res && res.locked) {
      pinMsg = 'PIN locked for 15 minutes. Please ask your manager';
    } else if (res && res.warning && typeof res.attemptsRemaining === 'number') {
      pinMsg = res.attemptsRemaining === 1
        ? 'Incorrect PIN: 1 more try before it locks'
        : 'Incorrect PIN: ' + res.attemptsRemaining + ' tries left before it locks';
    }
    document.getElementById('pinError').textContent = pinMsg;
    var card = document.querySelector('.pin-pad-card');
    card.classList.remove('pin-shake');
    void card.offsetWidth;
    card.classList.add('pin-shake');
  }
}
clock.checkClockPin = checkClockPin;

// ── manager ─────────────────────────────────────────────
export const manager = {};

function checkPin(){
  // DEPRECATED — store-level password replaces per-action PIN.
  // If this is somehow triggered, just unlock immediately.
  managerUnlocked=true;
  document.getElementById('managerPin').classList.remove('open');
  if(managerCallback){managerCallback();managerCallback=null;}
}
manager.checkPin = checkPin;

function closePin(){document.getElementById('managerPin').classList.remove('open');managerCallback=null;}
manager.closePin = closePin;
